import { render } from 'preact';
import { html } from 'htm/preact';
import ContactSearchWidget from './contact-search-widget';

function parseDataset({ input = '', fallback }) {
  try {
    return JSON.parse(input);
  } catch (err) {
    // Do nothing.
  }

  return fallback;
}

async function mount({ rootElement = null }) {
  // const preact = await import('preact');
  // const htm = await import('htm/preact');

  const {
    categories, serviceCategories, translations, language,
  } = rootElement.dataset;
  const container = rootElement.querySelector('.contact-search');

  const options = {
    categories: parseDataset({ input: categories, fallback: [] }),
    serviceCategories: parseDataset({ input: serviceCategories, fallback: [] }),
    translations: parseDataset({ input: translations, fallback: [] }),
    language,
  };

  render(html`
    <${ContactSearchWidget}
      categories=${options.categories}
      serviceCategories=${options.serviceCategories}
      translations=${options.translations}
      language=${options.language}
    />`, container);
}

function init() {
  const blocks = document.querySelectorAll('.section--contact-search');

  [...blocks].forEach((block) => {
    mount({ rootElement: block });
  });
}

export default init;
